import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformIAMPage from '@src/pages/Platform/IAM';

export const Route = createLazyFileRoute('/platform/iam')({
  component: PlatformIAMPageWithLayout,
});

function PlatformIAMPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformIAMPage />
    </DefaultLayout>
  );
}
